import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { ItemTaxationStatus, MenuItemCategory, MenuItemDisplayStyle } from "@biteinc/enums";
//#region src/utils/mod_utils.ts
var mod_utils_exports = /* @__PURE__ */ __exportAll({ defaults: () => defaults });
function defaults() {
	return {
		category: MenuItemCategory.Food,
		displayStyle: MenuItemDisplayStyle.NameAndDescription,
		isMod: true,
		taxationStatus: ItemTaxationStatus.Inherit
	};
}
//#endregion
export { defaults, mod_utils_exports };

//# sourceMappingURL=mod_utils.js.map